<template>
    
    <transition name="fade">
      <div class="badge-alert" v-if="show">
        <img src="@/assets/badges/peterpan.png">
        <div>
          <h2>Félicitations !</h2>
          <p>Tu as remporté le badge Peter pan !</p>
          <button class="primary reverse" v-on:click="show = false">Merci !</button>
        </div>
      </div>
  </transition>
</template>

<script>

export default {
  name: 'badgeAlert',
  components: {
  },

  data: function () {
    return {
      show: false
    }
  },

  watch: {
    '$store.state.badges.peterpan': function () {
      this.show = true
    }
  },

  mounted: function () {
  }
}
</script>


// WEBPACK FOOTER //
// src/components/badgeAlert.vue